import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { Volunteer } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService): GridSetup<Volunteer> {

	return {
		rowName: { singular: 'Removed Volunteer', plural: 'Removed Volunteers' },
		getRowKey: row => '' + row.volunteerId,
		stateKey: 'removed-volunteers-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, domainData, app),
	}
}
